import { HTTP_STATUS_CODE, IHttpGet } from '../../adapters';
import { ISheetFundRelated, ISheetFundRelatedResponse } from './dto';

export class SheetFundRelatedUseCase {
  constructor(
    private readonly url: string,
    private readonly http: IHttpGet<ISheetFundRelatedResponse[]>
  ) {}

  async execute(fundSlug: string): Promise<ISheetFundRelated[]> {
    const { statusCode, body } = await this.http.get({
      url: `${this.url}/${fundSlug}`,
    });

    switch (statusCode) {
      case HTTP_STATUS_CODE.ok:
        return body?.map((related) => ({ ...related }));

      default:
        return null;
    }
  }
}
